import React from 'react'
import { render } from 'react-snapshot'
import { Router, Route, Switch } from 'react-router'
import { createBrowserHistory } from 'history'

import Navbar from './components/Navbar'
import Footer from './components/Footer'

import Home from './pages/Home'
import Team from './pages/Team'
import Projects from './pages/Projects'
import News from './pages/News'
import Gallery from './pages/Gallery'
import Contact from './pages/Contact'
import Register from './pages/Register'
import Sponsor from './pages/Sponsor'
import Donate from './pages/Donate'

import School from './pages/blog/School'
import Playday from './pages/blog/Playday'
import PadDonation from './pages/blog/PadDonation'
import FeedingProgram from './pages/blog/FeedingProgram'
import SeneSchoolProgram from './pages/blog/SeneSchoolProgram'

import './css/global.css'

render(
  <Router history={createBrowserHistory()}>
    <Switch>
      <div id="app">
        <Navbar />

        <Route exact path="/" component={Home} />
        <Route exact path="/team" component={Team} />
        <Route exact path="/projects" component={Projects} />
        <Route exact path="/news" component={News} />
        <Route exact path="/gallery" component={Gallery} />
        <Route exact path="/contact" component={Contact} />
        <Route exact path="/donate" component={Donate} />
        <Route exact path="/sponsor" component={Sponsor} />
        <Route exact path="/register" component={Register} />
        <Route exact path="/blog/ehdo-organized-a-playday-at-adwa-ber-school" component={Playday} />
        <Route exact path="/blog/ehdo-launched-a-school-feeding-program" component={FeedingProgram} />
        <Route exact path="/blog/ehdo-participated-in-the-sene-30-school-program" component={SeneSchoolProgram} />
        <Route exact path="/blog/ehdo-founding-members-sisited-adwa-ber-and-wotatoch-genet-schools" component={School} />
        <Route exact path="/blog/ehdo-donated-feminine-sanitary-pads-to-adwa-ber-female-students" component={PadDonation} />

        <Footer />
      </div>
    </Switch>
  </Router>,
  document.getElementById('root')
)